import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const CompanyInfoContent = ({ setActiveFile }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <Helmet>
                <title>Our Company | We Are A Site</title>
                <meta name="description" content="We Are A Site is a team of Arizona-based developers helping small businesses succeed online with custom websites." />
            </Helmet>

            <div className='CompanyInfoContent'>
                <div className='AboutWindowFunctionBar'>
                    <button
                        onClick={() => {
                            setActiveFile(null);
                            navigate('/about');
                        }}
                    >Back</button>
                    <button style={{ cursor: "not-allowed" }}>File</button>
                    <button style={{ cursor: "not-allowed" }}>Edit</button>
                    <button style={{ cursor: "not-allowed" }}>View</button>
                    <button style={{ cursor: "not-allowed" }}>Help</button>
                </div>
                <div className='CompanyInfoContentText'>
                    <div className='CompanyInfoContentTextHeader'>
                        <img src='/images/MainLogo.png' alt='Preview' />
                        <div className='CompanyInfoContentTextInfo'>
                            <span className='BusinessAttribute BusinessName'><span className='BusinessLabel'>Company Name: </span>We Are A Site</span>
                            <span className='BusinessAttribute BusinessType'><span className='BusinessLabel'>Company Type: </span>Web Development</span>
                            <span className='BusinessAttribute BusinessEmployeeCount'><span className='BusinessLabel'>Total Number of Employees: </span>4</span>
                            <span className='BusinessAttribute BusinessNetWorth'><span className='BusinessLabel'>Net Worth: </span>Almost Bankrupt</span>
                        </div>
                    </div>
                    <div className='CompanyInfoContentTextParagraph'>
                        <h1>Description</h1>
                        <span>
                            We're four Arizona friends with computer science degrees, caffeine addictions, and a shared love for building awesome websites — the kind that actually move, scroll, blink, and bounce (on purpose).
                            <br /> <br />From smooth animations to full-on interactive sites, we've got the skills (and the memes) to bring your ideas to life. When we're not coding, you'll catch us battling it out in pc games, arguing over soccer scores, or shooting hoops.
                            <br /> <br />We're not some big, scary agency — just real people who know how to make a website look good and work even better.
                            <br /> <br />Need something custom? Animated? A little weird? Perfect.We're your team.
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyInfoContent